export enum LogLevels {
   Critical = 'Critical',
   Error = 'Error',
   Warning = 'Warning',
   Info = 'Info',
   Debug = 'Debug',
   Verbose = 'Verbose',
}
